export default __webpack_public_path__ + "3c661e2867268112147421ca2afb54d1.png";